// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import cx from 'classnames';
import { Table, TableBody, TableRow, TableCell } from '@material-ui/core';

const ItemInfo = ({
  classes,
  itemProperties,
  isPaddingBetweenRecords,
  alignValuesToRight,
  alignValuesToLeft,
  greyValues,
}) => (
  <Table>
    <TableBody>
      {itemProperties
        .filter(({ value }) => !_isEmpty(value))
        .map(({ value, label }) => (
          <TableRow key={label} className={isPaddingBetweenRecords ? classes.paddingBetweenRecords : null}>
            <TableCell className={classes.cell}>{label}</TableCell>
            <TableCell
              className={cx(
                classes.cell,
                !greyValues && classes.black,
                alignValuesToRight && classes.alignValuesToRight,
                alignValuesToLeft && classes.alignValuesToLeft,
              )}
            >
              {value}
            </TableCell>
          </TableRow>
        ))}
    </TableBody>
  </Table>
);

ItemInfo.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  itemProperties: PropTypes.arrayOf(PropTypes.shape({})),
  isPaddingBetweenRecords: PropTypes.bool,
  alignValuesToRight: PropTypes.bool,
  alignValuesToLeft: PropTypes.bool,
  greyValues: PropTypes.bool,
};

ItemInfo.defaultProps = {
  classes: {},
  itemProperties: [],
  isPaddingBetweenRecords: false,
  alignValuesToRight: false,
  alignValuesToLeft: false,
  greyValues: false,
};

export default ItemInfo;
